export enum FixCourseRebuildRideOptionEnum {
  RebuildCompletely = "RebuildCompletely",
  RebuildPartially = "RebuildPartially",
  RebuildPartiallyKeepTimes = "RebuildPartiallyKeepTimes",
  KeepEmptyStations = "KeepEmptyStations",
}
